module.exports = __webpack_public_path__ + "static/img/RP.e5036a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/company-logo/RP.png
// module id = emXp
// module chunks = 34